export default "__VITE_ASSET__7uEFw6q6__"